<template>
  <section>
    <b-table
      :data="schedules"
      :loading="loading"
      narrowed
      bordered
      :mobile-cards="false"
    >
      <b-table-column
        field="day"
        :label="$t('attributes.sort')"
        :width="80"
        numeric
        v-slot="props"
      >
        {{ props.row.day }}
      </b-table-column>

      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        v-slot="props"
      >
        {{ props.row.name }}
      </b-table-column>

      <b-table-column :width="70" label="功能" v-slot="props">
        <b-button
          type="is-primary"
          outlined
          @click.prevent="onModify(props.row)"
        >
          {{ $t('attributes.modify') }}
        </b-button>
      </b-table-column>

      <template #empty>
        <section class="section">
          <div v-if="!loading" class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
          </div>
        </section>
      </template>
    </b-table>

    <b-modal
      :active.sync="isFormModalActive"
      :sending="sending"
      :can-cancel="['escape', 'x']"
      :width="1200"
      has-modal-card
    >
      <schedule-form :schedule="selectedSchedule" :area="area" @send="onSend" />
    </b-modal>
  </section>
</template>

<script>
import { PRODUCTS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import ScheduleForm from './ScheduleForm'

export default {
  name: 'ScheduleList',
  components: { ScheduleForm },

  props: {
    product: {
      required: true,
      type: Object
    },
    area: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      code: this.product.code,
      schedules: [],

      sending: false,
      isFormModalActive: false,
      selectedSchedule: null
    }
  },
  watch: {
    product(newProduct) {
      this.code = newProduct.code
      this.isFormModalActive = false
      this.selectedSchedule = null
      this.loadSchedulesAsync(newProduct.code)
    }
  },
  mounted() {
    this.loadSchedulesAsync(this.product.code)
  },
  methods: {
    async loadSchedulesAsync(code) {
      try {
        this.loading = true
        const api = `${PRODUCTS_API}/${code}/schedules`
        const res = await this.axios.get(api)
        this.schedules = res.data.data.sort((t1, t2) => t1.day - t2.day)
      } catch (e) {
        this.schedules = []

        notifyService.fetch_error('schedule', e)
      } finally {
        this.loading = false
      }
    },
    onModify(item) {
      this.selectedSchedule = item
      this.isFormModalActive = true
    },
    async onSend(item) {
      const api = `${PRODUCTS_API}/${this.code}/schedules/${item.id}`

      try {
        this.sending = true
        const res = await this.axios.put(api, item)
        const _item = res.data.data

        this.schedules = this.schedules
          .map(schedule => (_item.id === schedule.id ? _item : schedule))
          .sort((t1, t2) => t1.day - t2.day)

        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
